import React, { Component, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { initGA } from "./components/tracking/Tracking";
import { MyProvider, MyContext } from './context.jsx';

import Navigation from './components/nav/Navigation.js';
import Footer from "./components/footer/Footer";
import Loader from "./components/loader/Loader";
import './App.scss';

const Index                = lazy(() => import("./pages/Index"));
const Laboratory           = lazy(() => import("./pages/Laboratory"));
const Work                 = lazy(() => import("./pages/Work"));
const WorkItem             = lazy(() => import("./pages/WorkItem"));
const Culture              = lazy(() => import("./pages/Culture"));
const Careers              = lazy(() => import("./pages/Careers"));
const CareersItem          = lazy(() => import("./pages/CareersItem"));
const Contact              = lazy(() => import("./pages/Contact"));
const Research             = lazy(() => import("./pages/Research"));
const ResearchProcess      = lazy(() => import("./pages/ResearchProcess"));
const ResearchTechniques   = lazy(() => import("./pages/ResearchTechniques"));
const ResearchDesign       = lazy(() => import("./pages/ResearchDesign"));
const MethodLinking        = lazy(() => import("./pages/MethodLinking"));
const GatheringData        = lazy(() => import("./pages/GatheringData"));
const Analysis             = lazy(() => import("./pages/Analysis"));
const BecomeARespondent    = lazy(() => import("./pages/BecomeARespondent"));
const OrderResearch        = lazy(() => import("./pages/OrderResearch"));
const ElearningResearch    = lazy(() => import("./pages/ElearningResearch"));
const EcommerceResearch    = lazy(() => import("./pages/EcommerceResearch"));
const AtlBtlResearch       = lazy(() => import("./pages/AtlBtlResearch"));
const DigitalResearch      = lazy(() => import("./pages/DigitalResearch"));
const Blog                 = lazy(() => import("./pages/Blog"));
const BlogItem             = lazy(() => import("./pages/BlogItem"));
const NotFound             = lazy(() => import("./pages/NotFound"));

const IndexEn              = lazy(() => import("./pages/en/Index"));
const LaboratoryEn         = lazy(() => import("./pages/en/Laboratory"));
const ContactEn            = lazy(() => import("./pages/en/Contact"));
const ResearchEn           = lazy(() => import("./pages/en/Research"));
const ResearchProcessEn    = lazy(() => import("./pages/en/ResearchProcess"));
const ResearchTechniquesEn = lazy(() => import("./pages/en/ResearchTechniques"));
const ResearchDesignEn     = lazy(() => import("./pages/en/ResearchDesign"));
const MethodLinkingEn      = lazy(() => import("./pages/en/MethodLinking"));
const GatheringDataEn      = lazy(() => import("./pages/en/GatheringData"));
const AnalysisEn           = lazy(() => import("./pages/en/Analysis"));
const BecomeARespondentEn  = lazy(() => import("./pages/en/BecomeARespondent"));
const OrderResearchEn      = lazy(() => import("./pages/en/OrderResearch"));
const ElearningResearchEn  = lazy(() => import("./pages/en/ElearningResearch"));
const EcommerceResearchEn  = lazy(() => import("./pages/en/EcommerceResearch"));
const AtlBtlResearchEn     = lazy(() => import("./pages/en/AtlBtlResearch"));
const DigitalResearchEn    = lazy(() => import("./pages/en/DigitalResearch"));
const BlogEn               = lazy(() => import("./pages/en/Blog"));
const BlogItemEn           = lazy(() => import("./pages/en/BlogItem"));

export class App extends Component {
    componentDidMount() {
        initGA('UA-142608572-1');
    }

    render() {
        return (
            <div className="App">
                <MyProvider>
                    <Router>
                        <MyContext.Consumer>
                            {(context) => (
                                <React.Fragment>
                                    <Navigation context={context} />
                                    <Suspense fallback={<Loader />}>
                                        <Switch>
                                            <Route path="/" exact component={Index} />
                                            <Route path="/laboratorium" exact component={Laboratory} />
                                            <Route path="/oferta-badan" exact component={Research} />
                                            <Route path="/proces-badawczy" exact component={ResearchProcess} />
                                            <Route path="/proces-badawczy/projektowanie-badan" exact component={ResearchDesign} />
                                            <Route path="/proces-badawczy/technika-laczenia-metod-badawczych" exact component={MethodLinking} />
                                            <Route path="/proces-badawczy/zbieranie-danych" exact component={GatheringData} />
                                            <Route path="/proces-badawczy/analiza-i-raport" exact component={Analysis} />
                                            <Route path="/research-techniques" exact component={ResearchTechniques} />
                                            <Route path="/research-design" exact component={ResearchDesign} />
                                            <Route path="/zostan-respondentem" exact component={BecomeARespondent} />
                                            <Route path="/zamow-badania" exact component={OrderResearch} />
                                            <Route path="/oferta-badan/badania-z-obszaru-elearning" exact component={ElearningResearch} />
                                            <Route path="/oferta-badan/badania-z-obszaru-ecommerce" exact component={EcommerceResearch} />
                                            <Route path="/oferta-badan/badania-z-obszaru-btl-atl" exact component={AtlBtlResearch} />
                                            <Route path="/oferta-badan/badania-z-obszaru-digital" exact component={DigitalResearch} />
                                            <Route path="/work" exact component={Work} />
                                            <Route path="/work/1" exact component={WorkItem} />
                                            <Route path="/culture" component={Culture} />
                                            <Route path="/careers" exact component={Careers} />
                                            <Route path="/careers/1" exact component={CareersItem} />
                                            <Route path="/kontakt" component={Contact} />
                                            <Route path="/blog" exact component={Blog} />
                                            <Route path="/blog/post/:id" component={BlogItem} />

                                            <Route path="/en/" exact component={IndexEn} />
                                            <Route path="/en/lab" exact component={LaboratoryEn} />
                                            <Route path="/en/research-offer" exact component={ResearchEn} />
                                            <Route path="/en/research-process" exact component={ResearchProcessEn} />
                                            <Route path="/en/research-process/designing-research" exact component={ResearchDesignEn} />
                                            <Route path="/en/research-process/combining-methods" exact component={MethodLinkingEn} />
                                            <Route path="/en/research-process/collecting-data" exact component={GatheringDataEn} />
                                            <Route path="/en/research-process/analysis-and-report" exact component={AnalysisEn} />
                                            <Route path="/en/research-techniques" exact component={ResearchTechniquesEn} />
                                            <Route path="/en/research-design" exact component={ResearchDesignEn} />
                                            <Route path="/en/become-a-respondent" exact component={BecomeARespondentEn} />
                                            <Route path="/en/order-research" exact component={OrderResearchEn} />
                                            <Route path="/en/research-offer/elearning-research" exact component={ElearningResearchEn} />
                                            <Route path="/en/research-offer/ecommerce-research" exact component={EcommerceResearchEn} />
                                            <Route path="/en/research-offer/btl-atl-research" exact component={AtlBtlResearchEn} />
                                            <Route path="/en/research-offer/digital-research" exact component={DigitalResearchEn} />
                                            <Route path="/en/contact" component={ContactEn} />
                                            <Route path="/en/blog" exact component={BlogEn} />
                                            <Route path="/en/blog/post/:id" component={BlogItemEn} />

                                            <Route component={NotFound} />
                                        </Switch>
                                    </Suspense>
                                    <Footer context={context} />
                                </React.Fragment>
                            )}
                        </MyContext.Consumer>
                    </Router>
                </MyProvider>
            </div>
        );
    }
}

export default App;
